import _slicedToArray from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _classPrivateFieldSet from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _toConsumableArray from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

var _Symbol$iterator;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { RenditionEvent } from "./rendition-event.js";
import { getPrivate } from "./utils.js";

function addRendition(track, rendition) {
  var renditionList = getPrivate(track).media.audioRenditions;
  getPrivate(rendition).media = getPrivate(track).media;
  getPrivate(rendition).track = track;
  var renditionSet = getPrivate(track).renditionSet;
  renditionSet.add(rendition);
  var index = renditionSet.size - 1;

  if (!(index in AudioRenditionList.prototype)) {
    Object.defineProperty(AudioRenditionList.prototype, index, {
      get: function get() {
        return getCurrentRenditions(this)[index];
      }
    });
  }

  queueMicrotask(function () {
    if (!track.enabled) return;
    renditionList.dispatchEvent(new RenditionEvent("addrendition", {
      rendition: rendition
    }));
  });
}

function removeRendition(rendition) {
  var renditionList = getPrivate(rendition).media.audioRenditions;
  var track = getPrivate(rendition).track;
  var renditionSet = getPrivate(track).renditionSet;
  renditionSet.delete(rendition);
  queueMicrotask(function () {
    var track2 = getPrivate(rendition).track;
    if (!track2.enabled) return;
    renditionList.dispatchEvent(new RenditionEvent("removerendition", {
      rendition: rendition
    }));
  });
}

function selectedChanged(rendition) {
  var renditionList = getPrivate(rendition).media.audioRenditions;
  if (!renditionList || getPrivate(renditionList).changeRequested) return;
  getPrivate(renditionList).changeRequested = true;
  queueMicrotask(function () {
    delete getPrivate(renditionList).changeRequested;
    var track = getPrivate(rendition).track;
    if (!track.enabled) return;
    renditionList.dispatchEvent(new Event("change"));
  });
}

function getCurrentRenditions(renditionList) {
  var media = getPrivate(renditionList).media;
  return _toConsumableArray(media.audioTracks).filter(function (track) {
    return track.enabled;
  }).flatMap(function (track) {
    return _toConsumableArray(getPrivate(track).renditionSet);
  });
}

var _addRenditionCallback = /*#__PURE__*/new WeakMap();

var _removeRenditionCallback = /*#__PURE__*/new WeakMap();

var _changeCallback = /*#__PURE__*/new WeakMap();

_Symbol$iterator = Symbol.iterator;

var AudioRenditionList = /*#__PURE__*/function (_EventTarget) {
  _inherits(AudioRenditionList, _EventTarget);

  var _super = _createSuper(AudioRenditionList);

  function AudioRenditionList() {
    var _this;

    _classCallCheck(this, AudioRenditionList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _addRenditionCallback, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _removeRenditionCallback, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _changeCallback, {
      writable: true,
      value: void 0
    });

    return _this;
  }

  _createClass(AudioRenditionList, [{
    key: _Symbol$iterator,
    value: function value() {
      return getCurrentRenditions(this).values();
    }
  }, {
    key: "length",
    get: function get() {
      return getCurrentRenditions(this).length;
    }
  }, {
    key: "getRenditionById",
    value: function getRenditionById(id) {
      var _getCurrentRenditions;

      return (_getCurrentRenditions = getCurrentRenditions(this).find(function (rendition) {
        return "".concat(rendition.id) === "".concat(id);
      })) !== null && _getCurrentRenditions !== void 0 ? _getCurrentRenditions : null;
    }
  }, {
    key: "selectedIndex",
    get: function get() {
      return getCurrentRenditions(this).findIndex(function (rendition) {
        return rendition.selected;
      });
    }
  }, {
    key: "selectedIndex",
    set: function set(index) {
      var _iterator = _createForOfIteratorHelper(getCurrentRenditions(this).entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              i = _step$value[0],
              rendition = _step$value[1];

          rendition.selected = i === index;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "onaddrendition",
    get: function get() {
      return _classPrivateFieldGet(this, _addRenditionCallback);
    }
  }, {
    key: "onaddrendition",
    set: function set(callback) {
      if (_classPrivateFieldGet(this, _addRenditionCallback)) {
        this.removeEventListener("addrendition", _classPrivateFieldGet(this, _addRenditionCallback));

        _classPrivateFieldSet(this, _addRenditionCallback, void 0);
      }

      if (typeof callback == "function") {
        _classPrivateFieldSet(this, _addRenditionCallback, callback);

        this.addEventListener("addrendition", callback);
      }
    }
  }, {
    key: "onremoverendition",
    get: function get() {
      return _classPrivateFieldGet(this, _removeRenditionCallback);
    }
  }, {
    key: "onremoverendition",
    set: function set(callback) {
      if (_classPrivateFieldGet(this, _removeRenditionCallback)) {
        this.removeEventListener("removerendition", _classPrivateFieldGet(this, _removeRenditionCallback));

        _classPrivateFieldSet(this, _removeRenditionCallback, void 0);
      }

      if (typeof callback == "function") {
        _classPrivateFieldSet(this, _removeRenditionCallback, callback);

        this.addEventListener("removerendition", callback);
      }
    }
  }, {
    key: "onchange",
    get: function get() {
      return _classPrivateFieldGet(this, _changeCallback);
    }
  }, {
    key: "onchange",
    set: function set(callback) {
      if (_classPrivateFieldGet(this, _changeCallback)) {
        this.removeEventListener("change", _classPrivateFieldGet(this, _changeCallback));

        _classPrivateFieldSet(this, _changeCallback, void 0);
      }

      if (typeof callback == "function") {
        _classPrivateFieldSet(this, _changeCallback, callback);

        this.addEventListener("change", callback);
      }
    }
  }]);

  return AudioRenditionList;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));

export { AudioRenditionList, addRendition, removeRendition, selectedChanged };